import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { PackageInventoryQueryParams } from '../../../helpers/packageInventory';
import type { FetchProjectsResponse } from '../../../../shared/organizationPackages/response';

const fetchPackageVersionProjects = (
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) => get<FetchProjectsResponse>(
  `/api/packages/${nuc(locator)}/versions/${encodeURIComponent(version)}/projects`,
  true,
  params,
  { encodeQuery: true },
);

export const getPackageVersionProjectsQueryKey = (
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) => ['packages', locator, 'versions', version, 'projects', params] as const;

export default function usePackageVersionProjects(
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) {
  return useQuery<FetchProjectsResponse>({
    queryKey: getPackageVersionProjectsQueryKey(locator, version, params),
    queryFn: () => fetchPackageVersionProjects(locator, version, params),
    enabled: Boolean(locator && version),
    staleTime: 1000 * 60 * 5,
    // Keep the previous page's total so the pagination footer does not vanish while a new page loads.
    // eslint-disable-next-line @typescript-eslint/no-deprecated -- React Query v4 option required by this migration.
    keepPreviousData: true,
  });
}
